<div class="update-load-component" *ngIf="currentOrder$ | async as currentOrder">
  <div class="head-wrap">
    <div class="flex flex-row justify-between items-center">
      <h1>Update {{ currentOrder.saUniqueId }}</h1>
      <div>
        <button
          type="submit"
          *ngIf="currentOrder.dataLockDetails?.isLocked && userService.isAdmin()"
          mat-flat-button
          color="primary"
          [disabled]="togglingLockData$$ | async"
          (click)="toggleLock(currentOrder.id, false, currentOrder.dataLockDetails?.canUnlock)"
          [matTooltip]="
            (currentOrder.dataLockDetails?.lastActionUserName
              ? 'Locked by ' +
                currentOrder.dataLockDetails?.lastActionUserName +
                ' on ' +
                (currentOrder.dataLockDetails?.lastActionTimestamp | date: 'short')
              : 'Locked') + (currentOrder.dataLockDetails?.canUnlock ? '. Click to unlock.' : '.')
          "
        >
          Unlock
        </button>
        <ng-container *saAllowedAccountRoles="['admin']">
          <button
            type="submit"
            *ngIf="currentOrder.dataLockDetails?.isLocked === false"
            mat-flat-button
            color="primary"
            [disabled]="togglingLockData$$ | async"
            (click)="toggleLock(currentOrder.id, true, currentOrder.dataLockDetails?.canLock)"
            [matTooltip]="currentOrder.dataLockDetails?.canLock ? 'Click to lock.' : null"
          >
            Lock
          </button>
        </ng-container>
      </div>
    </div>
    <h4>{{ currentOrder.user?.name }}, {{ currentOrder.truck?.name }}</h4>
  </div>

  <form [formGroup]="editForm" *ngIf="editForm" class="edit-form" (ngSubmit)="updateOrder()">
    <mat-form-field>
      <input matInput placeholder="Ticket Number" type="text" autocomplete="off" formControlName="ticketNumber" />
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        type="text"
        placeholder="BOL Number"
        formControlName="bolNumber"
        autocomplete="off"
        [readonly]="loaderDataLocked"
        [matTooltip]="loaderDataLocked ? 'LMO updated this field' : ''"
      />
    </mat-form-field>

    <ng-container *ngIf="currentOrder.boxes" formArrayName="boxes">
      <div class="box-wrap" *ngFor="let box of boxes.controls; trackBy: trackById; let i = index" [formGroupName]="i">
        <mat-form-field>
          <input matInput type="text" placeholder="Box ID" formControlName="name" autocomplete="off" />
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            sa-number-input
            min="0"
            [max]="maxWeight"
            type="text"
            placeholder="Box Load Weight (lbs)"
            formControlName="actualLoadWeight"
            [readonly]="loaderDataLocked"
            [matTooltip]="loaderDataLocked ? 'LMO updated this field' : ''"
          />
          <mat-hint>Max {{ maxWeight | number }}</mat-hint>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngIf="!currentOrder.boxes">
      <mat-form-field>
        <input
          matInput
          sa-number-input
          min="0"
          [max]="maxWeight"
          type="text"
          placeholder="Final Load Weight"
          formControlName="actualLoadWeight"
          [readonly]="loaderDataLocked"
          [matTooltip]="loaderDataLocked ? 'LMO updated this field' : ''"
        />
        <mat-hint>Max {{ maxWeight | number }}</mat-hint>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="text" placeholder="Bulk Storage Number" formControlName="bulkStorageNumber" />
      </mat-form-field>
    </ng-container>

    <mat-form-field>
      <textarea
        matInput
        placeholder="Description"
        type="text"
        autocomplete="off"
        formControlName="description"
        rows="4"
      ></textarea>
    </mat-form-field>

    <div class="button-wrap">
      <button type="submit" mat-flat-button color="primary" [disabled]="submitting$ | async">Submit</button>
    </div>
  </form>
</div>
